import React from "react";
import dayjs from "dayjs";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import { Grid, IconButton } from "@material-ui/core";
import { DPReactSelect } from "Components/DP/DPReactSelect/DPReactSelect";
import { selectStyle } from "./selectStyles";
import { getMonths } from "./services/getMonths";
import useStyles from "./styles";

export interface SelectOption {
  value: dayjs.Dayjs;
  label: string;
}

export interface CustomHeaderProps {
  date: Date;
  changeYear(year: number): void;
  changeMonth(month: number): void;
  decreaseMonth(): void;
  increaseMonth(): void;
  prevMonthButtonDisabled: boolean;
  nextMonthButtonDisabled: boolean;
  minDate: Date;
  maxDate: Date;
}

const CustomHeader = (props: CustomHeaderProps) => {
  const classes = useStyles();
  const {
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled
  } = props;
  const selectedDate = dayjs(date);
  const maxDate = dayjs(props.maxDate);
  const minDate = dayjs(props.minDate);

  const monthYearsOptions: SelectOption[] = getMonths(minDate, maxDate).map(month => ({
    value: month,
    label: month.format("MMM YYYY"),
  }));

  return (
    <Grid container justify="space-between">
      <Grid item xs={5}>
        <DPReactSelect
          value={{
            value: selectedDate,
            label: selectedDate.format("MMM YYYY")
          }}
          options={monthYearsOptions}
          onChange={(newOption: SelectOption) => {
            changeMonth(newOption.value.month());
            changeYear(newOption.value.year());
          }}
          className={classes.reactSelect}
          components={{
            IndicatorSeparator: () => null
          }}
          styles={selectStyle}
        />
      </Grid>
      <Grid item xs={6} container alignItems="center" justify="flex-end">
        <IconButton onClick={decreaseMonth} disabled={prevMonthButtonDisabled} className={classes.navButton}>
          <NavigateBeforeIcon />
        </IconButton>
        <IconButton onClick={increaseMonth} disabled={nextMonthButtonDisabled} className={classes.navButton}>
          <NavigateNextIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
};

export default CustomHeader;
